import { defineComponent as _defineComponent } from 'vue'
import { GET } from '@/admin-shared-modules/utils/ajax'
import { date } from '@/admin-shared-modules/utils/format'
import { onMounted, ref } from 'vue'
import Edit from './edit.vue'
import { store } from './store'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const list = store.list
const search = store.search

onMounted(() => {
  fetchLabels()
  store.list.fetch()
})

const labels = ref([])
async function fetchLabels() {
  try {
    const res = await GET('template_rule/labels', {})
    labels.value = res.data
  } catch (error) {}
}
function onSubmit() {
  store.list.fetch({ reset: true })
}

return { __sfc: true,list, search, labels, fetchLabels, onSubmit, date, Edit, store }
}

})